export function aboutInfoAnimate() {
    const isDesktop = !this.isTouch;
    const $window = $(window);
    const aboutInfo = $(".about-us-info-holder");
    let animationTop = aboutInfo.offset().top;
    let top = $window.scrollTop();
    let animateImage = $(".hero-slider");

    if (isDesktop) {
        $window.on("load scroll", function () {
            setTimeout(function () {
                top = $window.scrollTop();
                let i = 0;
                if (top > $window.innerHeight() * 0.2 && !animateImage.hasClass("hide")) {
                    animateImage.removeClass("show").addClass("hide");
                }
                if (top < $window.innerHeight() * 0.2 && animateImage.hasClass("hide")) {
                    animateImage.removeClass("hide").addClass("show");
                }
                if (top > animationTop - $window.innerHeight() * 0.8 && !aboutInfo.hasClass("animated")) {
                    aboutInfo.addClass("animated");
                    $(".trg- + i + ").addClass("show");
                    setInterval(function () {
                        if (i < 17) {
                            $(".trg-" + i + "").addClass("show");
                            i++;
                        }
                    }, 50);

                }
            }, 200);
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/aboutInfoAnimate.js